import home from './home';
import test from './test';

export default { home, test };


// WEBPACK FOOTER //
// ./src/locales/zh-CN/index.ts